module.exports = __webpack_public_path__ + "img/apartment-purple.d716ef44.png";